import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const Preloader = () => (
  <div className='bg-bw00 rounded-[8px] shadow-light w-[456px] h-[600px] flex flex-col items-center justify-center'>
    <Skeleton className='mb-[16px]' width='400px' height='32px' count={1} />
    <Skeleton width='400px' height='400px' count={1} />
  </div>
);
